// JS provides difference from current TZ to UTC instead of the time zone,
// so we work with that instead of normal time zone
// e.g. PST DST = UTC -7 = 9AM_PSTDST == 4PM_UTC, a diff of 7 hours or 420 min
// const UTC_DIFFERENCE_MINUTES = (new Date()).getTimezoneOffset();
// leave this in here for repl.it
const UTC_DIFFERENCE_MINUTES = -(-7 * 60)
const MINUTES_MAXIMUM = 7 * 24 * 60
const MINUTES_MAXIMUM_TZ = MINUTES_MAXIMUM + (-1 * UTC_DIFFERENCE_MINUTES)
const MINUTES_MINIMUM = 0
const MINUTES_MINIMUM_TZ = MINUTES_MINIMUM + (-1 * UTC_DIFFERENCE_MINUTES)
const DAY_SUN = 0
const DAY_MON = 1
const DAY_TUE = 2
const DAY_WED = 3
const DAY_THU = 4
const DAY_FRI = 5
const DAY_SAT = 6
export const daysOfWeek = [
  'Sun',
  'Mon',
  'Tue',
  'Wed',
  'Thu',
  'Fri',
  'Sat',
]

const pad = (value, size) => {
  let s = String(value)
  while (s.length < (size || 2)) { s = `0${s}` }
  return s
}

export const formatTime = (hr, min) => {
  return `${pad(hr)}:${pad(min)}`
}

const scheduleStartDecode = value => value >> 16 >>> 0
const scheduleStopDecode = value => value & 0xFFFF >>> 0
const scheduleEncode = (start, stop) => (((start << 16) >>> 0) | ((stop & 0xFFFF) >>> 0))

const scheduleRing = (value) => {
  let result = value
  if (value >= 10080) result = value - 10080
  else if (value < 0) result = value + 10080

  if (result < 0 || result >= 10080) throw new Error('Input value bad ' + result)
  else return result & 0xFFFF
}

const scheduleRingUnion = (nStart, nStop, oStart, oStop) => {
  if (nStart > MINUTES_MAXIMUM || nStart < MINUTES_MINIMUM) throw new Error('Bad nStart value')
  if (nStop > MINUTES_MAXIMUM || nStop < MINUTES_MINIMUM) throw new Error('Bad nStop value')
  if (oStart > MINUTES_MAXIMUM || oStart < MINUTES_MINIMUM) throw new Error('Bad oStart value')
  if (oStop > MINUTES_MAXIMUM || oStop < MINUTES_MINIMUM) throw new Error('Bad oStop value')

  if (nStart > nStop) nStop += MINUTES_MAXIMUM
  if (oStart > oStop) oStop += MINUTES_MAXIMUM

  if (nStop - MINUTES_MAXIMUM > oStart) oStart += MINUTES_MAXIMUM
  if (nStop - MINUTES_MAXIMUM > oStop) oStop += MINUTES_MAXIMUM
  if (oStop - MINUTES_MAXIMUM > nStart) nStart += MINUTES_MAXIMUM
  if (oStop - MINUTES_MAXIMUM > nStop) nStop += MINUTES_MAXIMUM

  if (
    (nStart >= oStart && nStart <= oStop) || // nStart between oStart and oStop
    (oStart >= nStart && oStart <= nStop) // oStart between nStart and nStop
  ) {
    const output = {
      start: scheduleRing(Math.min(nStart, oStart)),
      stop: scheduleRing(Math.max(nStop, oStop)),
    }
    return output
  }
  return false
}

export const insertTime = (
  scheduleEvents,
  dayStart, hourStart, minStart,
  dayStop, hourStop, minStop,
  utcDifferenceMinutes
) => {
  if (!Array.isArray(scheduleEvents)) throw new Error('Invalid scheduleEvents array')
  if (dayStart > 6 || dayStart < 0) throw new Error('Invalid start day')
  if (dayStop > 6 || dayStop < 0) throw new Error('Invalid stop day')
  if (hourStart > 23 || hourStart < 0) throw new Error('Invalid start hour')
  if (hourStop > 23 || hourStop < 0) throw new Error('Invalid stop hour')
  if (minStart > 59 || minStart < 0) throw new Error('Invalid start min')
  if (minStop > 59 || minStop < 0) throw new Error('Invalid stop min')
  if (utcDifferenceMinutes > 720 || utcDifferenceMinutes < -840) throw new Error('Invalid UTC Difference')

  // create our start minutes value
  let start = dayStart * 24 * 60
  start += hourStart * 60
  start += minStart

  // create our stop minutes value
  let stop = dayStop * 24 * 60
  stop += hourStop * 60
  stop += minStop

  // adjust for UTC
  start += utcDifferenceMinutes
  stop += utcDifferenceMinutes

  // limit to between 0 and 10080
  start = scheduleRing(start)
  stop = scheduleRing(stop)

  // create array for the new schedule
  const acc = []
  if (scheduleEvents.length < 1) {
    // no previous scheduleEvents, so nothing to de-dupe
    acc.push(scheduleEncode(start, stop))
  } else {
    // the rest of this is to de-dupe intervals
    let newStart = start
    let newStop = stop

    // loop through old schedule and figure out where to put new value
    scheduleEvents.map((schedEvent) => {
      let oldStart = scheduleStartDecode(schedEvent)
      let oldStop = scheduleStopDecode(schedEvent)

      let intervalCombined = false
      // check if the intervals overlap
      if (scheduleRingUnion(newStart, newStop, oldStart, oldStop)) {
        // since they overlap take the max and mins of the two intervals
        // we are attempting to maximize the duration

        newStart = scheduleRingUnion(newStart, newStop, oldStart, oldStop).start
        newStop = scheduleRingUnion(newStart, newStop, oldStart, oldStop).stop
        intervalCombined = true
        // console.log('intervals combined', oldStart, oldStop, newStart, newStop)
      } else {
        // console.log('intervals with no overlap', oldStart, oldStop, newStart, newStop)
      }

      if (!intervalCombined) {
        // if there was no overlap, insert our old values into the array
        oldStart = scheduleRing(oldStart)
        oldStop = scheduleRing(oldStop)
        acc.push(scheduleEncode(oldStart, oldStop))
      }
    })

    // don't do this until the end or we will get dupe values
    newStart = scheduleRing(newStart)
    newStop = scheduleRing(newStop)
    acc.push(scheduleEncode(newStart, newStop))
  }

  // sort for consistency
  acc.sort((a, b) => (a - b))
  const j = 0
  // acc.map(output => console.log(`Output ${j++}: ${decodeTime(output, utcDifferenceMinutes).human}`));
  return acc
}

export const insertTimeDuration = (
  scheduleEvents,
  dayStart, hourStart, minStart,
  duration,
  utcDifferenceMinutes
) => {
  // create our start minutes value
  let start = dayStart * 24 * 60
  start += hourStart * 60
  start += minStart

  const stop = start + duration
  // 0 for UTC offset, due to this doubling up on offset.
  const decoded = decodeTime(scheduleEncode(start, stop), 0)

  return insertTime(
    scheduleEvents,
    decoded.start.day, decoded.start.hr, decoded.start.min,
    decoded.stop.day, decoded.stop.hr, decoded.stop.min,
    utcDifferenceMinutes
  )
}

export const decodeTime = (schedEvent, offset, key = 0) => {
  let start = scheduleStartDecode(schedEvent) - offset
  let stop = scheduleStopDecode(schedEvent) - offset

  start = scheduleRing(start)
  stop = scheduleRing(stop)

  let positiveStop = stop
  if (start > stop) positiveStop = stop + MINUTES_MAXIMUM

  // put our basic calculated values in place
  const timesDecoded = {
    start: {
      day: Math.floor(start / (24 * 60)),
      hr: Math.floor(start / 60) - ((Math.floor(start / (24 * 60))) * 24),
      min: start % 60,
      human: '',
    },
    stop: {
      day: Math.floor(stop / (24 * 60)),
      hr: Math.floor(stop / 60) - ((Math.floor(stop / (24 * 60))) * 24),
      min: stop % 60,
      human: '',
    },
    duration: {
      hrs: Math.round((positiveStop - start) / 60),
      mins: positiveStop - start,
      size: (positiveStop - start) > (4 * 60) ? 1 : 0,
      cross: false,
      crossWeek: false,
    },
    human: '',
  }

  if (Number(key) || Number(key) === 0) timesDecoded.key = Number(key)

  // determine if it crosses an end of day
  timesDecoded.duration.cross = timesDecoded.start.day !== timesDecoded.stop.day && timesDecoded.start.day <= timesDecoded.stop.day
  timesDecoded.duration.crossWeek = timesDecoded.start.day > timesDecoded.stop.day
  // write out our human readable values
  timesDecoded.start.human = `${daysOfWeek[timesDecoded.start.day]} ${timesDecoded.start.hr > 12 ? timesDecoded.start.hr - 12 : timesDecoded.start.hr}:${pad(timesDecoded.start.min)} ${timesDecoded.start.hr >= 12 ? 'PM' : 'AM'}`
  timesDecoded.stop.human = `${daysOfWeek[timesDecoded.stop.day]} ${timesDecoded.stop.hr > 12 ? timesDecoded.stop.hr - 12 : timesDecoded.stop.hr}:${pad(timesDecoded.stop.min)} ${timesDecoded.stop.hr >= 12 ? 'PM' : 'AM'}`
  timesDecoded.human = `Start: ${timesDecoded.start.human}, Stop: ${timesDecoded.stop.human} (${schedEvent})`

  // calculate if a scheduled item lasts 7 days, as this item is wonky
  const sevenDay = (timesDecoded.start.day === timesDecoded.stop.day && timesDecoded.start.hr > timesDecoded.stop.hr)
  // calculate number of days we are running for
  if (timesDecoded.start.day <= timesDecoded.stop.day && !sevenDay) {
    timesDecoded.duration.days = timesDecoded.stop.day - timesDecoded.start.day
  } else {
    timesDecoded.duration.days = (timesDecoded.stop.day + 7) - timesDecoded.start.day
    // cross is always true if start > stop or we have 7 day run
    timesDecoded.duration.cross = true
  }

  return timesDecoded
}

export const decodeScheduleUI = (schedule, offset = 0) => {
  if (!schedule || !Array.isArray(schedule) || schedule.length < 1) return false
  const array = []
  for (let i = 0; i < schedule.length; i++) {
    const answer = decodeTime(schedule[i], offset, i)

    if (answer.start.day <= answer.stop.day && !(answer.duration.days === 7)) {
      array.push(answer)
    } else {
      // if a multi-day run, we need to split for our UI
      const answer2 = JSON.parse(JSON.stringify(answer))

      answer.stop.day = 6
      answer.duration.days = answer.stop.day - answer.start.day

      answer2.start.day = 0
      answer2.duration.days = answer2.stop.day - answer2.start.day

      if (answer.start.day === 6) {
        answer.duration.size = 24 - answer.start.hr >= 4 ? 1 : 0
        answer.duration.cross = false
      }
      if (answer.stop.day === 0) {
        answer2.duration.size = answer2.stop.hr >= 4 ? 1 : 0
        answer2.duration.cross = false
      }
      answer2.start.day = 0

      array.push(answer, answer2)
    }
  }
  return array
}
